"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAddressRowValue = void 0;
const getAddressRowValue = (addressRowConfigItem, address)=>{
    const propertyName = addressRowConfigItem.charAt(0).toLowerCase() + addressRowConfigItem.slice(1);
    var _address_propertyName;
    return (_address_propertyName = address[propertyName]) !== null && _address_propertyName !== void 0 ? _address_propertyName : '';
};
exports.getAddressRowValue = getAddressRowValue;
